import Keycloak from 'keycloak-js'
import { currentENV } from './PropertySearch/Utility/Utility.js'
import envConfig from './Common/envConfig/envConfig'

let keycloakParam = envConfig[currentENV()].KEYCLOCK_PATH
const keycloak = new Keycloak(keycloakParam)

export default keycloak
